export default __webpack_public_path__ + "static/media/footer-naturkost.57444e53.png";